import React from 'react';
import ReactSortContainer from 'react-dnd-container';


/**
 * Diagnoses Cards Remover component
 */
const DiagnosesCardsRemover = (props) => {
  let cards = [];
  let order = 0;
  props.selected.map((key) => {
    cards.push(
        {
          key: key,
          label: props.data.data[key].label,
          onRemove: props.onRemove,
          order: ++order,
        }
    );
  });

  const style = {
    minHeight: 100,
  };
  return(
      <div className="nppe2-fc-diagnoses-cards-remover">
        <div>
          <ReactSortContainer
              group='nppe2-fc-diagnoses-cards-remover'
              vertical style={style}
              itemRender={item}
              cards={cards}
              onChange={(e) => props.onOrder(e)}
          />
        </div>
      </div>
  )
};

const item = (itemData, props) => {
  const style = {
    opacity: props.isDragging ? 0.5 : 1,
  };
  return (
    <div className="nppe2-fc-close-drag-button" style={style}>
      <div className="nppe2-fc-close-drag-button__btn">
        <div className="nppe2-fc-close-drag-button__number">
          {itemData.order}
        </div>
        <div className="nppe2-fc-close-drag-button__drag">
        </div>
        <div className="nppe2-fc-close-drag-button__text">
          {itemData.label}
        </div>
        <div className="nppe2-fc-close-drag-button__close">
          <a onClick={() => itemData.onRemove(itemData.key)}>
            x
          </a>
        </div>
      </div>
    </div>
  )
};

export default DiagnosesCardsRemover;
